import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ListingContextType {
  isPostListingModalOpen: boolean;
  openPostListingModal: () => void;
  closePostListingModal: () => void;
  navigateToPostAd: () => void;
  selectedHub: string | null;
  setSelectedHub: (hub: string | null) => void;
}

const ListingContext = createContext<ListingContextType | undefined>(undefined);

export const ListingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [isPostListingModalOpen, setIsPostListingModalOpen] = useState(false);
  const [selectedHub, setSelectedHub] = useState<string | null>(null);

  const openPostListingModal = () => setIsPostListingModalOpen(true);
  const closePostListingModal = () => setIsPostListingModalOpen(false);
  const navigateToPostAd = () => {
    navigate('/post-listing');
  };

  return (
    <ListingContext.Provider
      value={{
        isPostListingModalOpen,
        openPostListingModal,
        closePostListingModal,
        navigateToPostAd,
        selectedHub,
        setSelectedHub,
      }}
    >
      {children}
    </ListingContext.Provider>
  );
};

export const useListing = () => {
  const context = useContext(ListingContext);
  if (context === undefined) {
    throw new Error('useListing must be used within a ListingProvider');
  }
  return context;
};
